<section class="n-whatsapp-config flex flex-column gap-3">
  @if (estabelecimentoDataService.$planoQuotas() && !$temZap()) {
    <div class="n-page-header">
      <div class="n-header-content">
        <div class="n-header-info">
          <h1>{{ 'BARDO_WHATSAPP.TITULO' | translate }}</h1>
          <p>
            {{ 'BARDO_WHATSAPP.PLANO_SEM_ZAP' | translate: { plano: estabelecimentoDataService.$planoQuotas()?.nome || 'atual' } }}
          </p>
        </div>
      </div>
    </div>
  } @else {
  <div class="n-page-header">
    <div class="n-header-content">
      <div class="n-header-info" data-tour="whatsapp-prereq">
        <h1>{{ 'BARDO_WHATSAPP.TITULO' | translate }}</h1>
        <p>
          {{ 'BARDO_WHATSAPP.SUBTITULO' | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="n-content-layout" data-tour="whatsapp-acoes">
    @if ($mostrarEscolhaMetodo()) {
    <div
      class="n-status-card"
      data-tour="whatsapp-status"
      [attr.data-status]="visualStatus"
    >
      <div class="n-status-left">
        <div class="n-status-icon-wrapper">
          <div class="n-status-icon">
            <i [class]="currentStatusConfig.Icon"></i>
          </div>
          <div
            class="n-status-pulse"
            [class.n-active]="
              whatsappConfigDataService.$whatsappConfig().status ===
                'conectando' ||
              whatsappConfigDataService.$whatsappConfig().status ===
                'reconectando'
            "
          ></div>
        </div>

        <div class="n-status-info">
          <div class="n-status-header">
            <h2 class="n-status-title">{{ currentStatusConfig.textKey ? (currentStatusConfig.textKey | translate) : currentStatusConfig.Text }}</h2>
            <span class="n-status-badge" [attr.data-status]="visualStatus">
              {{ currentStatusConfig.badgeTextKey ? (currentStatusConfig.badgeTextKey | translate) : currentStatusConfig.BadgeText }}
            </span>
          </div>
          <p class="n-status-description">
            {{ currentStatusConfig.descriptionKey ? (currentStatusConfig.descriptionKey | translate) : currentStatusConfig.Description }}
          </p>
          <div class="n-status-details">
            @if (whatsappConfigDataService.$whatsappConfig().telefone) {
            <div class="n-detail-item">
              <i class="pi pi-phone"></i>
              <span>{{
                formatarTelefone(
                  whatsappConfigDataService.$whatsappConfig().telefone ?? ''
                )
              }}</span>
            </div>
            } @if ( whatsappConfigDataService.$whatsappConfig().ultimaConexao &&
            whatsappConfigDataService.$whatsappConfig().status === 'conectado' )
            {
            <div class="n-detail-item">
              <i class="pi pi-clock"></i>
              <span>
                {{
                  'BARDO_WHATSAPP.STATUS.CONECTADO_EM'
                    | translate: { dataHora: formatarDataHora(whatsappConfigDataService.$whatsappConfig().ultimaConexao) }
                }}
              </span>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="n-status-actions">
        @switch (visualStatus) { @case ('desconectado') {
        <div class="n-action-group">
          <!-- Contador de cooldown -->
          @if (whatsappConfigDataService.$tempoRestanteCountdown() > 0) {
          <small class="n-cooldown-message">
            <i class="pi pi-clock"></i>
            {{ 'BARDO_WHATSAPP.STATUS.AGUARDE_COOLDOWN' | translate: { segundos: whatsappConfigDataService.$tempoRestanteCountdown() } }}
          </small>
          }

          @if(whatsappConfigDataService.$whatsappConectado()){
          <p-button
            [label]="'BARDO_WHATSAPP.BOTOES.DESCONECTAR' | translate"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            (click)="removerInstancia()"
            [disabled]="!whatsappConfigDataService.$podeGerarCode()"
          ></p-button>
          }
        </div>
        } @case ('qrExpirado') {
        <div class="n-action-group">
          @if(whatsappConfigDataService.$whatsappConectado()){
          <p-button
            [label]="'BARDO_WHATSAPP.BOTOES.DESCONECTAR' | translate"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            (click)="removerInstancia()"
            [disabled]="!whatsappConfigDataService.$podeGerarCode()"
          ></p-button>
          }
        </div>
        } @case ('conectado') {
        <div class="n-action-group">
          <p-button
            [label]="'BARDO_WHATSAPP.BOTOES.VERIFICAR_STATUS' | translate"
            icon="pi pi-sync"
            severity="secondary"
            [outlined]="true"
            (click)="verificarStatus()"
            [loading]="$testando()"
          ></p-button>

          @if(whatsappConfigDataService.$whatsappConectado()){
          <p-button
            [label]="'BARDO_WHATSAPP.BOTOES.DESCONECTAR' | translate"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            (click)="removerInstancia()"
            [disabled]="!whatsappConfigDataService.$podeGerarCode()"
          ></p-button>
          }
        </div>
        } @case ('erro') {
        <div class="n-action-group">
          @if(whatsappConfigDataService.$whatsappConectado()){
          <p-button
            [label]="'BARDO_WHATSAPP.BOTOES.DESCONECTAR' | translate"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            (click)="removerInstancia()"
            [disabled]="!whatsappConfigDataService.$podeGerarCode()"
          ></p-button>
          }
        </div>
        } @case ('conectando') { @if
        (whatsappConfigDataService.$tempoRestanteCountdown() > 0) {
        <small class="n-cooldown-message">
          <i class="pi pi-clock"></i>
          {{ 'BARDO_WHATSAPP.STATUS.AGUARDE_COOLDOWN' | translate: { segundos: whatsappConfigDataService.$tempoRestanteCountdown() } }}
        </small>
        } }}
      </div>
    </div>

    @if (whatsappConfigDataService.$whatsappConfig().status !== 'conectado') {
    <!-- CONEXÃO STEPS -->
    <div class="n-connection-steps">
      <!-- STEP 0: ESCOLHA DO MÉTODO -->
      @if ($currentStep() === 0) {
      <div class="n-method-choice" [@fadeInUp]>
        <h4>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.TITULO' | translate }}</h4>
        <p class="n-choice-subtitle">{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.SUBTITULO' | translate }}</p>

        <div class="n-methods-grid">
          <!-- Opção QR Code -->
          <button
            type="button"
            class="n-method-card n-method-card--qr"
            (click)="escolherQRCode()"
            [disabled]="
              !whatsappConfigDataService.$podeGerarCode() &&
              whatsappConfigDataService.$pairingCodeGenerated()
            "
          >
            <div class="n-method-icon">
              <i class="pi pi-qrcode"></i>
            </div>
            <h5>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.QR_CODE_TITULO' | translate }}</h5>
            <p>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.QR_CODE_DESC' | translate }}</p>
            <ul class="n-method-steps">
              <li>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.QR_CODE_VANTAGEM_1' | translate }}</li>
              <li>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.QR_CODE_VANTAGEM_2' | translate }}</li>
              <li>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.QR_CODE_VANTAGEM_3' | translate }}</li>
            </ul>
          </button>

          <!-- Opção Pairing Code -->
          <button
            type="button"
            class="n-method-card n-method-card--pairing"
            (click)="escolherPairingCode()"
            [disabled]="
              !whatsappConfigDataService.$podeGerarCode() &&
              whatsappConfigDataService.$qrCodeB64()
            "
          >
            <div class="n-method-icon">
              <i class="pi pi-mobile"></i>
            </div>
            <h5>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.PAIRING_TITULO' | translate }}</h5>
            <p>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.PAIRING_DESC' | translate }}</p>
            <ul class="n-method-steps">
              <li>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.PAIRING_VANTAGEM_1' | translate }}</li>
              <li>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.PAIRING_VANTAGEM_2' | translate }}</li>
              <li>{{ 'BARDO_WHATSAPP.ESCOLHA_METODO.PAIRING_VANTAGEM_3' | translate }}</li>
            </ul>
          </button>
        </div>

        <div class="text-center mt-4">
          <p-button
            [label]="'BARDO_WHATSAPP.BOTOES.CANCELAR' | translate"
            severity="secondary"
            [text]="true"
            (onClick)="fecharEscolhaMetodo()"
          ></p-button>
        </div>
      </div>
      }

      <!-- STEP 1: QR CODE -->
      @if ($currentStep() === 1) {
      <div class="n-step-container" [@fadeInUp]>
        <div class="n-step-header">
          <div class="n-step-icon">
            <i class="pi pi-qrcode"></i>
          </div>
          <h2>{{ 'BARDO_WHATSAPP.STEP_QR.TITULO' | translate }}</h2>
          <p class="n-step-description">
            {{ 'BARDO_WHATSAPP.STEP_QR.SUBTITULO' | translate }}
          </p>
        </div>

        <div class="n-step-layout">
          <!-- INSTRUÇÕES (ESQUERDA) -->
          <div class="n-instructions-column">
            <h3 class="n-instructions-title">{{ 'BARDO_WHATSAPP.STEP_QR.COMO_CONECTAR' | translate }}</h3>
            <div class="n-instructions-list">
              <div class="n-instruction-item">
                <div class="n-instruction-number">1</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_QR.PASSO_1' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">2</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_QR.PASSO_2' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">3</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_QR.PASSO_3' | translate"></div>
              </div>
            </div>

            <!-- BOTÃO VOLTAR -->
            <div class="n-step-actions mt-3">
              <p-button
                [label]="'BARDO_WHATSAPP.BOTOES.VOLTAR' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [text]="true"
                (click)="voltarParaEscolha()"
                [disabled]="!whatsappConfigDataService.$podeGerarCode()"
              ></p-button>
            </div>

            <!-- OPÇÃO SEM CÂMERA -->
            @if ($showCodeOption()) {
            <div class="n-code-option" [@slideInOut]>
              <div class="n-code-info">
                <i class="pi pi-info-circle"></i>
                <p>
                  {{ 'BARDO_WHATSAPP.STEP_QR.SEM_CAMERA_INFO' | translate }}
                </p>
              </div>
              <p-button
                [label]="'BARDO_WHATSAPP.BOTOES.CONECTAR_COM_CODIGO' | translate"
                icon="pi pi-key"
                severity="secondary"
                [outlined]="true"
                (click)="conectarPorCodigo()"
                [disabled]="!podeAbrirPairingCode"
              ></p-button>
            </div>
            }
          </div>

          <!-- QR CODE (DIREITA) -->
          <div class="n-qr-column">
            <div class="n-qr-display">
              @if (whatsappConfigDataService.$loading()) {
              <div class="n-qr-loading">
                <i class="pi pi-spin pi-spinner"></i>
                <span>{{ 'BARDO_WHATSAPP.STEP_QR.GERANDO_QR' | translate }}</span>
              </div>
              } @else if (whatsappConfigDataService.$qrCodeB64() ||
              whatsappConfigDataService.$codeExpired()) {
              @if(whatsappConfigDataService.$qrCodeB64()){

              <div class="n-qr-image">
                <img
                  [src]="whatsappConfigDataService.$qrCodeB64()"
                  [alt]="'BARDO_WHATSAPP.STEP_QR.ALT_QR' | translate"
                />
              </div>
              } @if ( whatsappConfigDataService.$codeExpired() ) {
              <div class="n-qr-expired-overlay">
                <i class="pi pi-exclamation-triangle"></i>
                <span>{{ 'BARDO_WHATSAPP.STEP_QR.QR_EXPIRADO' | translate }}</span>
                <button class="n-btn-refresh" (click)="atualizarQRCode()">
                  <i class="pi pi-refresh"></i>
                  {{ 'BARDO_WHATSAPP.BOTOES.GERAR_NOVO_CODIGO' | translate }}
                </button>
              </div>
              } } @else {
              <div class="n-qr-placeholder">
                <i class="pi pi-qrcode"></i>
                <span>{{ 'BARDO_WHATSAPP.STEP_QR.PLACEHOLDER_CLIQUE' | translate }}</span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }

      <!-- STEP 2: DIGITAR NÚMERO DE CELULAR -->
      @if ($currentStep() === 2) {
      <div class="n-step-container" [@fadeInUp]>
        <div class="n-step-header">
          <div class="n-step-icon">
            <i class="pi pi-mobile"></i>
          </div>
          <h2>{{ 'BARDO_WHATSAPP.STEP_PHONE.TITULO' | translate }}</h2>
          <p class="n-step-description">
            {{ 'BARDO_WHATSAPP.STEP_PHONE.SUBTITULO' | translate }}
          </p>
        </div>

        <div class="n-step-layout">
          <!-- INSTRUÇÕES (ESQUERDA) -->
          <div class="n-instructions-column">
            <h3 class="n-instructions-title">{{ 'BARDO_WHATSAPP.STEP_PHONE.INFO_IMPORTANTE' | translate }}</h3>
            <div class="n-instructions-list">
              <div class="n-instruction-item">
                <div class="n-instruction-number">
                  <i class="pi pi-info-circle"></i>
                </div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_PHONE.INFO_DDD' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">
                  <i class="pi pi-check-circle"></i>
                </div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_PHONE.INFO_BUSINESS' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">
                  <i class="pi pi-globe"></i>
                </div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_PHONE.INFO_EXEMPLO' | translate"></div>
              </div>
            </div>

            <!-- AÇÃO DE VOLTAR -->
            <div class="n-step-actions">
              <p-button
                [label]="'BARDO_WHATSAPP.BOTOES.VOLTAR' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [text]="true"
                (click)="voltarParaEscolha()"
                [disabled]="!whatsappConfigDataService.$podeGerarCode()"
              ></p-button>
            </div>
          </div>

          <!-- FORMULÁRIO (DIREITA) -->
          <div class="n-phone-step-panel">
            <div class="n-phone-input-container">
              <label for="phoneNumber" class="n-phone-label">
                <i class="pi pi-mobile"></i>
                {{ 'BARDO_WHATSAPP.STEP_PHONE.LABEL_NUMERO' | translate }}
              </label>
              <div class="n-phone-input-wrapper">
                <lib-phone-input
                  [value]="$phoneNumber()"
                  (valueChange)="setPhoneNumber($event)"
                />
              </div>
              <p-button
                [label]="'BARDO_WHATSAPP.BOTOES.GERAR_CODIGO' | translate"
                icon="pi pi-arrow-right"
                severity="primary"
                [disabled]="
                  !numeroConexaoValido() ||
                  !whatsappConfigDataService.$podeGerarCode()
                "
                (click)="conectarPorCodigo()"
                styleClass="w-full mt-3"
              ></p-button>
            </div>
          </div>
        </div>
      </div>
      }

      <!-- STEP 3: CÓDIGO DE PAREAMENTO -->
      @if ($currentStep() === 3) {
      <div class="n-step-container" [@fadeInUp]>
        <div class="n-step-header">
          <div class="n-step-icon">
            <i class="pi pi-key"></i>
          </div>
          <h2>{{ 'BARDO_WHATSAPP.STEP_CODE.TITULO' | translate }}</h2>
          <p class="n-step-description">{{ 'BARDO_WHATSAPP.STEP_CODE.SUBTITULO' | translate }}</p>
        </div>

        <div class="n-step-layout">
          <!-- INSTRUÇÕES (ESQUERDA) -->
          <div class="n-instructions-column">
            <h3 class="n-instructions-title">{{ 'BARDO_WHATSAPP.STEP_CODE.COMO_USAR' | translate }}</h3>
            <div class="n-instructions-list">
              <div class="n-instruction-item">
                <div class="n-instruction-number">1</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_CODE.PASSO_1' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">2</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_CODE.PASSO_2' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">3</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_CODE.PASSO_3' | translate"></div>
              </div>
              <div class="n-instruction-item">
                <div class="n-instruction-number">4</div>
                <div class="n-instruction-text" [innerHTML]="'BARDO_WHATSAPP.STEP_CODE.PASSO_4' | translate"></div>
              </div>
            </div>

            <!-- AÇÃO DE VOLTAR -->
            <div class="n-step-actions">
              <p-button
                [label]="'BARDO_WHATSAPP.BOTOES.VOLTAR' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [text]="true"
                (click)="voltarParaTelefone()"
                [disabled]="!whatsappConfigDataService.$podeGerarCode()"
              ></p-button>
            </div>
          </div>

          <!-- CÓDIGO (DIREITA) -->
          <div class="n-code-column">
            <div class="n-pairing-code-display">
              <div class="n-code-label">{{ 'BARDO_WHATSAPP.STEP_CODE.SEU_CODIGO' | translate }}</div>
        <div
          class="n-code-value"
          role="button"
          tabindex="0"
          [title]="'BARDO_WHATSAPP.STEP_CODE.COPIAR_TOOLTIP' | translate"
          (click)="copiarCodigoConexao()"
          (keydown.enter)="copiarCodigoConexao(); $event.preventDefault()"
          (keydown.space)="copiarCodigoConexao(); $event.preventDefault()"
        >
          {{ whatsappConfigDataService.$pairingCodeGenerated() }}
        </div>
              <div class="n-code-hint">
                <i class="pi pi-clock"></i>
                {{ 'BARDO_WHATSAPP.STEP_CODE.EXPIRA_EM' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }

    <!-- CONFIGURAÇÕES AVANÇADAS (APENAS QUANDO CONECTADO) -->
    @if (whatsappConfigDataService.$whatsappConectado()) {
    <lib-whatsapp-settings-panel />
    } } @else {
    <div class="n-disabled-container">
      <div class="n-disabled-content">
        <div class="n-disabled-icon">
          <i class="pi pi-whatsapp"></i>
        </div>
        <h2>{{ 'BARDO_WHATSAPP.TELA_DESCONECTADA.TITULO' | translate }}</h2>
        <p>
          {{ 'BARDO_WHATSAPP.TELA_DESCONECTADA.SUBTITULO' | translate }}
        </p>
      </div>

      <div class="n-features-grid">
        <div class="n-feature-item">
          <i class="pi pi-calendar"></i>
          <span>{{ 'BARDO_WHATSAPP.TELA_DESCONECTADA.BENEFICIO_AGENDAMENTOS' | translate }}</span>
        </div>
        <div class="n-feature-item">
          <i class="pi pi-bell"></i>
          <span>{{ 'BARDO_WHATSAPP.TELA_DESCONECTADA.BENEFICIO_NOTIFICACOES' | translate }}</span>
        </div>
        <div class="n-feature-item">
          <i class="pi pi-comments"></i>
          <span>{{ 'BARDO_WHATSAPP.TELA_DESCONECTADA.BENEFICIO_RESPOSTAS' | translate }}</span>
        </div>
        <div class="n-feature-item">
          <i class="pi pi-chart-line"></i>
          <span>{{ 'BARDO_WHATSAPP.TELA_DESCONECTADA.BENEFICIO_RELATORIOS' | translate }}</span>
        </div>
      </div>

      <div class="n-activation-cta">
        <p-button
          [label]="'BARDO_WHATSAPP.BOTOES.ATIVAR' | translate"
          icon="pi pi-power-off"
          styleClass="n-button-prim"
          size="large"
          (click)="ativarWhatsApp()"
        ></p-button>
      </div>
    </div>
    }
  </div>
  }
</section>

<!-- Mobile: Bottom Sheet -->
@if ($isMobile() && modalConfirmacao) {
<lib-bottom-sheet
  [(visible)]="$internalModalVisible"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!whatsappConfigDataService.$loading()"
  [closeOnEscape]="!whatsappConfigDataService.$loading()"
  [preventClose]="whatsappConfigDataService.$loading()"
  [headerTemplate]="headerTemplate"
  [footerTemplate]="footerTemplate"
  (hide)="modalConfirmacao = false"
>
  <ng-container *ngTemplateOutlet="conteudoModal"></ng-container>
</lib-bottom-sheet>
}

<!-- Desktop: Dialog -->
@if (!$isMobile()) {
<p-dialog
  [header]="'BARDO_WHATSAPP.MODAL_DESCONECTAR.TITULO' | translate"
  [modal]="true"
  [(visible)]="$internalModalVisible"
  [style]="{ width: '450px' }"
  [closable]="!whatsappConfigDataService.$loading()"
  [dismissableMask]="false"
  styleClass="n-modal-whatsapp-confirm"
  (onHide)="modalConfirmacao = false"
>
  <ng-container *ngTemplateOutlet="conteudoModal"></ng-container>

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerContent"></ng-container>
  </ng-template>
</p-dialog>
}

<!-- Template de conteúdo compartilhado -->
<ng-template #conteudoModal>
  <div class="n-confirmation-dialog">
    <div class="n-warning-section">
      <div class="n-warning-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <div class="n-warning-content">
        <h4>{{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.CONFIRMAR_TITULO' | translate }}</h4>
        <p>
          {{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.MENSAGEM' | translate }}
        </p>
      </div>
    </div>

    <div class="n-impact-list">
      <div class="n-impact-item">
        <i class="pi pi-times-circle"></i>
        <span>{{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.IMPACTO_AGENDAMENTOS' | translate }}</span>
      </div>
      <div class="n-impact-item">
        <i class="pi pi-times-circle"></i>
        <span>{{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.IMPACTO_LEMBRETES' | translate }}</span>
      </div>
      <div class="n-impact-item">
        <i class="pi pi-times-circle"></i>
        <span>{{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.IMPACTO_COMUNICACAO' | translate }}</span>
      </div>
    </div>

    <div class="n-confirmation-note">
      <i class="pi pi-info-circle"></i>
      <span>{{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.NOTA_RECONECTAR' | translate }}</span>
    </div>
  </div>
</ng-template>

<!-- Templates compartilhados -->
<ng-template #headerTemplate>
  <h3 class="n-modal-title">{{ 'BARDO_WHATSAPP.MODAL_DESCONECTAR.TITULO' | translate }}</h3>
</ng-template>

<ng-template #footerTemplate>
  <ng-container *ngTemplateOutlet="footerContent"></ng-container>
</ng-template>

<ng-template #footerContent>
  <div class="n-dialog-actions">
    <p-button
      [label]="'BARDO_WHATSAPP.MODAL_DESCONECTAR.BOTAO_CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      (click)="modalConfirmacao = false"
      [disabled]="whatsappConfigDataService.$loading()"
    ></p-button>
    <p-button
      [label]="'BARDO_WHATSAPP.MODAL_DESCONECTAR.BOTAO_DESCONECTAR' | translate"
      severity="danger"
      (click)="confirmarRemocao()"
      [loading]="whatsappConfigDataService.$loading()"
    ></p-button>
  </div>
</ng-template>
